<template>
  <div class="pure-g">
    <div class="pure-u-md-1-5 pure-u-lg-1-4"></div>
    <div class="pure-u-1 pure-u-md-3-5 pure-u-lg-1-2">
      <div class="content box padding-30-reactive">

        <div v-if="active" class="pure-g">
          <div class="pure-u-1-2"><h3 class="responsive">{{step}}. Review</h3></div>

          <div class="pure-u-1 spacing-20"></div>

          <div class="pure-u-1">


            <div v-for="text in summary" class="summary">
              <div class="pure-u-sm-1-4"></div>
              <div class="pure-u-1 pure-u-sm-1-2 padding-bottom-10">{{text}}</div>
            </div>

            <div class="pure-u-1 spacing-20"></div>

            <div class="pure-u-1 pure-u-sm-1-4"></div>
            <div class="pure-u-1 pure-u-sm-1-2">
              <button class=" pure-button pure-button-primary block padding-10 margin-10 margin-left-0" @click="success">
                {{buttonText}}
              </button>
            </div>
          </div>
        </div>

        <div v-else class="pure-u-1">
          <h3 class="responsive">{{step}}. Review</h3>
          <button v-if="canEdit && !active" v-on:click="edit" class="link-lookalike">Review</button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import store from '../../lib/store';

  export default {
    name: 'ReviewDirect',
    data() {
      return {
        agreed: false,
        canEdit: false,
        error: false,
        summary: store.get('review_summary'),
        buttonText: store.get('review_button_text'),
      };
    },
    props: ['active', 'step'],
    watch: {
      active() {
        if (this.active) {
          /* global ga */
          ga('send', 'pageview', `/${store.get('subscription')}/Review`);
        }
      },
    },
    methods: {
      success() {
        this.$emit('success');
      },
      edit() {
        this.$emit('editView', 'Review');
      },
      setCanEdit() {
        this.canEdit = true;
      },
    },
  };
</script>


<style scoped>
  label {
    margin-top: 10px;
    margin-right: 10px;
  }

  input {
    margin-right: 10px;
  }
</style>



<style>
  body {
    /*background-color: white !important;*/
    /*background-image: none !important;*/
  }
</style>


// WEBPACK FOOTER //
// ReviewDirect.vue?279cdc30